import {createApp} from 'vue'
import options from './FlowHeader.options'

const el = '.kb-component--flow-header'

export default function(Store){
    const FlowHeaderDOM = document.querySelector(el)
    if(FlowHeaderDOM){
        const template = FlowHeaderDOM.innerHTML
        options.template = template
        
        const isStafet = FlowHeaderDOM.hasAttribute('is-stafet')
        const isIndependent = FlowHeaderDOM.hasAttribute('is-independent')
        const component = createApp(options, {isIndependent, isStafet}).use(Store)
        component.mount(FlowHeaderDOM)

    }
}

